import { updatesData } from '@/mocks/home-data';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            实时快讯
          </h2>
          <span className="flex items-center gap-1 text-xs text-primary-500 font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            LIVE
          </span>
        </div>
        <p className="text-sm text-foreground-600 mb-8">
          全天候滚动更新，第一时间掌握娱乐圈最新动态
        </p>

        <div className="relative">
          <div className="absolute left-[11px] top-0 bottom-0 w-px bg-background-200"></div>
          <div className="space-y-0">
            {updatesData.map((item) => (
              <div key={item.id} className="relative pl-8 pb-6 last:pb-0">
                <div className="absolute left-0 top-1 w-[23px] h-[23px] rounded-full bg-background-50 border-2 border-primary-300 flex items-center justify-center">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                </div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-500 font-mono">{item.time}</span>
                  <span
                    className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium ${
                      item.tag === '独家'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '热爆'
                          ? 'bg-accent-100 text-accent-800'
                          : item.tag === '新瓜'
                            ? 'bg-secondary-100 text-secondary-700'
                            : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.source}</span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed font-medium">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}